import type { RuleType } from '@duke-hq/billing/types/rules';

export const RULE_TYPE_LABELS: Record<RuleType, string> = {
  INVOICE_DAY_OF_MONTH: 'Invoice on day of month',
  DUE_TERMS_NET_DAYS: 'Due terms: NET n days',
  PRICE_OVERRIDE: 'Override price',
  DISCOUNT_PERCENT: 'Discount (percent)',
  DISCOUNT_FIXED: 'Discount (fixed amount)',
  FIRST_N_PRICE: 'First N at fixed price',
  FIRST_N_DISCOUNT_PERCENT: 'First N with percent discount',
  FIRST_N_DISCOUNT_FIXED: 'First N with fixed discount',
};

export const RULE_TYPE_SHORT_LABELS: Record<RuleType, string> = {
  INVOICE_DAY_OF_MONTH: 'Invoice Day',
  DUE_TERMS_NET_DAYS: 'NET Terms',
  PRICE_OVERRIDE: 'Price Override',
  DISCOUNT_PERCENT: '% Discount',
  DISCOUNT_FIXED: 'Fixed Discount',
  FIRST_N_PRICE: 'First N Price',
  FIRST_N_DISCOUNT_PERCENT: 'First N %',
  FIRST_N_DISCOUNT_FIXED: 'First N Fixed',
};
